import { i18nMark } from '@lingui/react';

export const byteSizes: { [x: string]: string } = {
  Байт: i18nMark('Байт'),
  Кб: i18nMark('Кб'),
  Мб: i18nMark('Мб'),
  Гб: i18nMark('Гб'),
  Тб: i18nMark('Тб'),
};
